module.exports = __webpack_public_path__ + "icon-remove.svg?b25b51d7821c35e968abbe1bb9a247e5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-remove.svg
// module id = 609
// module chunks = 0